module.exports = __webpack_public_path__ + "img/infos.5bfd959a.png";